import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, Sanitizer } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TaskModel } from '../../task.model';
import { MatDialogRef } from '@angular/material/dialog';
import { faEdit, faPlus, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { ErrorStateMatcher } from '@angular/material/core';
import { Observable } from 'rxjs';
import { IMenuItem } from '../../../../core/models/plugin.model';
import { AudioProcessorTaskBlock, IAudioProcessorTask } from '../../../../core/models/audio-processor-task.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/** Error when invalid control is dirty, touched, or submitted. */
export class TaskNameErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-task-creator-info',
  templateUrl: 'task.creator.info.component.html',
  styleUrls: ['task.creator.info.component.scss']
})
export class TaskCreatorInfoComponent implements OnInit {

  faEdit = faEdit;
  faPlus = faPlus;
  faCircleInfo = faCircleInfo;
  block!: AudioProcessorTaskBlock;
  searchModeOption = 'contains';
  searchExprOption: any = 'caption';
  searchTimeoutOption = 200;
  minSearchLengthOption = 0;
  showDataBeforeSearchOption = false;
  filteredToMenuItems!: Observable<IMenuItem[]>;
  toMenuItems: IMenuItem[] = [];
  toDropdownInstance!: any;


  constructor(
    public taskModel: TaskModel,
    private dialogRef: MatDialogRef<TaskCreatorInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.block = data.block;
    this.toMenuItems = data.toMenuItems;
  }

  ngOnInit() {  }

  onToDropdownInitialized(event: any) {
    this.toDropdownInstance = event.component;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  onToValueChanged(event: any) {
    if (!event.value) {
      this.block.menuItems[1] = this.toMenuItems[0];
    } else {
      this.block.menuItems[1] = event.value;
    }
  }

}
